const MenuItems = [
    {
        label: 'about_us',
        hasSubMenu: true,
        submenu: [
            { label: 'CEO_message', link: '/CEOMessage' },            
            { label: 'board_of_directors', link: '/BoardOfDirectors' },
            { label: 'specialized_committees', link: '/Committees', showInDemo: true },
            { label: 'statute', link: '/IrenexStatute', showOnlyinFA:true },
            { label: 'market_overview', link: '/IrenexAtGlance' },
            {
                label: 'codal_reports',
                link: 'https://codal.ir/ReportList.aspx?search&Symbol=%D8%A7%D9%86%D8%B1%DA%98%DB%8C&LetterType=-1&Isic=671203&AuditorRef=-1&PageNumber=1&Audited&NotAudited&IsNotAudited=false&Childs&Mains&Publisher=false&CompanyState=0&Category=-1&CompanyType=1&Consolidatable&NotConsolidatable',
                showOnlyinFA: true
            },
            { label: 'organizational_structure', link: '/OrganizationChart' },
            { label: 'trading_fees', link: '/TradesFee' },
            { label: 'SustainabilityReport', link: '/SustainabilityReport', showOnlyinFA: true },
        ],
    },
    {
        label: 'market',
        hasSubMenu: true,
        submenu: [
            { label: 'physical_market', link: '/PhysicalMarket/TradeBoard' },
            { label: 'derivative_market', link: '/DerivativeMarket/TradeBoard' },
            { label: 'other_securities_market', link: '/OtherTradableSecurities/TradeBoard' },
            { label: 'power_market', link: '/PowerMarket/TradeBoard' },
            { label: 'statistical_reports', link: '/Market/Report', showOnlyinFA: true },
        ],
    },
    {
        label: 'reception',
        hasSubMenu: true,
        submenu: [
            { label: 'reception_overview', link: '/Listing/ListingIntroduction' },
            { label: 'prospectuses', link: '/Listing/Prospectus/PhysicalProspectus', showOnlyinFA: true },
            /*{ label: 'کالاها و اوراق بهادار پذیرفته‌شده', link: '/Listing/Instruments' },*/
            { label: 'supply_statements', link: '/Listing/SupplyStatementsList', showOnlyinFA: true },
            { label: 'product_analysis', link: '/Analyze' },
            { label: 'consultant_ranking', link: '/Listing/RankingOfListingConsultants', showOnlyinFA: true },
            { label: 'inventories', link: '/Listing/Inventories', showOnlyinFA: true },
        ],
    },
    {
        label: 'chain_value',
        hasSubMenu: true,
        submenu: [
            { label: 'associate_suppliers_producers', link: '/ValueChain/Producers', showOnlyinFA: true },
            { label: 'offered_products', link: '/ValueChain/Commodities', showOnlyinFA: true },
            { label: 'registered_brokers', link: '/ValueChain/Brokers' },
            { label: 'calendar', link: '/ValueChain/Calendar', showOnlyinFA: true },
        ],
        showInDemo:false
    },
    {
        label: 'regulations',
        link: '/Rules',
        hasSubMenu: false,
        showOnlyinFA: true,
    },
    {
        label: 'encyclopedia',
        link: '/Encyclopedia',
        hasSubMenu: false,
        showInDemo: false,
        /*comingSoon: true,*/
        showOnlyinFA: true      
    },
    {
        label: 'systems',
        link: '/',
        hasSubMenu: false,
        /*comingSoon: true,*/
        showOnlyinFA: true
    },
];

export default MenuItems;